import Class from '@/modules/widget-yard/c-widget/c-content-chart-radius-pie-for-budget/c-view/c-view';
import '@/modules/widget-yard/c-widget/c-content-chart-radius-pie-for-budget/c-view/c-view@';

export default Class;